import React, { useState } from 'react';
import ScrollableStandingsTable from './Tables/ScrollableStandingsTable';
import StandingsFilter from './Filters/StandingsFilter';
import { useStandings } from '../../hooks/standings';
import { sortStandings, filterStandings } from '../../utils/functionalUtils';
import { useMatchesMinimized } from '../../hooks/matches';
import { addFormToRow } from '../../utils/standings';

function Standings({
  showForm = true,
  sortable,
  showSeasonSelection = true,
  isWidget = false,
}) {
  const [season, setSeason] = useState(window.currentSeason);
  const [formShow, setFormShow] = useState(showForm);
  const [sortKey, setSortKey] = useState('pts');
  const [sortDirection, setSortDirection] = useState('desc');
  const [standingsType, setStandingsType] = useState('total');
  const [data, dataLoading] = useStandings(season, standingsType);
  const [allMatches, allMatchesIsLoading] = useMatchesMinimized(season);

  const standings = (function getStandings() {
    if (!data) {
      return [];
    }

    const output = (() => {
      const sortedStandings = filterStandings(
        sortStandings(data, sortKey, sortDirection)
      );

      if (parseInt(season, 10) < 2025) {
        return sortedStandings;
      }
      const borderPositions = (() => {
        if (window.siteUrl.includes('allsvenskan')) {
          return [3, 13, 14];
        }
        if (window.siteUrl.includes('superettan')) {
          return [2, 3, 12, 14];
        }
        return [];
      })();

      return sortedStandings.map((row, index) => {
        if (borderPositions.includes(index + 1)) {
          return {
            ...row,
            borderType: 'borderbottom',
          };
        }

        return {
          ...row,
          borderType: 'noborder',
        };
      });
    })();

    if (showForm) {
      if (allMatchesIsLoading) {
        return output;
      }

      const finishedMatches = (allMatches || []).filter(
        (match) => match.status === 'FINISHED'
      );

      return output.map(addFormToRow(finishedMatches, standingsType));
    }

    return output;
  })();

  const headers = [
    {
      className: 'standings-table__games',
      sortKey: 'gp',
      label: 'S',
      shortLabel: 'S',
    },
    {
      className: 'standings-table__wins',
      sortKey: 'w',
      label: 'V',
      shortLabel: 'V',
    },
    {
      className: 'standings-table__ties',
      sortKey: 't',
      label: 'O',
      shortLabel: 'O',
    },
    {
      className: 'standings-table__losses',
      sortKey: 'l',
      label: 'F',
      shortLabel: 'F',
    },
    {
      className: 'standings-table__goals-scored',
      sortKey: 'gf',
      label: 'GM',
      shortLabel: 'GM',
      // shortLabel: '+',
    },
    {
      className: 'standings-table__goals-conceded',
      sortKey: 'ga',
      label: 'IM',
      shortLabel: 'IM',
      // shortLabel: '-',
    },
    {
      className: 'standings-table__goals-difference',
      sortKey: 'd',
      label: 'MS',
      shortLabel: 'MS',
      // shortLabel: '±',
    },
    {
      className: 'standings-table__points',
      sortKey: 'pts',
      label: 'Poäng',
      shortLabel: 'Poäng',
      // shortLabel: 'P',
    },
  ];
  return (
    <div className={`row ${!isWidget ? 'tabs-content' : ''}`}>
      <div className="col-12 tabs-column mt-0">
        <div className="py-4">
          <div className="row py-0 justify-content-end">
            {isWidget ? (
              <div className="heading-h6 heading-sm-h3 col-4 px-4">
                Tabellen
              </div>
            ) : null}
            <div className={isWidget ? 'col-8 px-3' : 'col-12'}>
              <StandingsFilter
                setSeason={setSeason}
                season={season}
                setFormShow={showForm && setFormShow}
                formShow={formShow}
                standingsType={standingsType}
                setStandingsType={setStandingsType}
                showSeasonSelection={showSeasonSelection}
                isWidget={isWidget}
              />
            </div>
          </div>
        </div>
        <ScrollableStandingsTable
          season={season}
          data={standings}
          formShow={formShow}
          dataLoading={dataLoading}
          sortable={sortable !== false}
          sortKey={sortKey}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          setSortKey={setSortKey}
          headers={headers}
          isWidget={isWidget}
        />
      </div>
    </div>
  );
}
export default Standings;
